import React from 'react';
import { useApp } from "../context/appContext";
import '../styles/PreferredOptometristSelector.css';


const PreferredOptometristSelector = ({ staff }) => {

  const { form, setForm } = useApp()

  const selectStaff = (value) => {
    setForm((prevForm) => ({
      ...prevForm,
      staffId: value,
      staffName: staff.find((optometrist) => optometrist.PIAB__Staff_Member__c === value)?.Staff_Name__c
    }))
  }

  return (
    <div className="preferred-optometrist-selector">
      <h3>Preferred Optometrist (Optional)</h3>
      <select value={form?.staffId} onChange={(e) => selectStaff(e.target.value)}>
        <option value="any">Any Optometrist</option>
        {staff?.length > 0 && staff?.map((optometrist) => (
          <option key={optometrist.PIAB__Staff_Member__c} value={optometrist.PIAB__Staff_Member__c}>{optometrist.Staff_Name__c}</option>
        ))}
      </select>
    </div>
  );
};

export default PreferredOptometristSelector;
